import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DomService {

  bodyTag: any = document.body;

  constructor(private http: HttpClient) { }

  addClassToBody(className) {
    this.bodyTag.classList.add(className);
  }

  removeClassFromBody(className) {
    this.bodyTag.classList.remove(className);
  }

}
